import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
    },
    containerFlex: {
        flex: 1,
    },
    alignCenter: {
        alignItems: 'center',
    },
    containerRowCenter: {
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'center',
        alignContent: 'center',
    },
    containerItem: {
        flex: 1,
        flexDirection: 'row',
        paddingRight: 12,
        paddingVertical: 5,
        alignItems: 'center',
        alignSelf: 'center',
    },
    image: {
        marginLeft: 15,
        width: 80,
        height: 80,
        borderRadius: 5,
    },
    containerData: {
        flex: 1,
        alignItems: 'flex-start',
        justifyContent: 'center',
        //justifyContent: 'space-between',
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        lineHeight: 20,
    },
    formTitle: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        lineHeight: 22,
        marginVertical: 8,
        marginHorizontal: 12,
        marginTop: 6,
    },
    itemTitle: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        lineHeight: 22,
        marginVertical: 8,
        marginHorizontal: 12,
        paddingBottom: 12,
        paddingTop: 3,
    },
    description: {
        fontSize: 16,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 12,
        marginTop: 4,
        //marginTop: 'auto',
    },
    description_short: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: '600',
        textAlign: 'left',
        paddingHorizontal: 12,
        marginTop: 4,
        //marginTop: 'auto',
    },
    ean: {
        fontSize: 14,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        paddingHorizontal: 12,
        marginTop: 4,
        //marginTop: 'auto',
    },
    oldPrice: {
        fontSize: 18,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingTop: 5,
        paddingHorizontal: 15,
        textDecorationLine: 'line-through',
        //marginTop: 'auto',
    },
    newPrice: {
        fontSize: 18,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingTop: 5,
        paddingHorizontal: 15,
        //marginTop: 'auto',
    },
    containerMiniButton: {
        flexDirection: 'row',
        width: 84,
        borderWidth: 2,
        borderRadius: 5,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
    },
    containerMiniButtonBisSelected: {
        flexDirection: 'row',
        width: 88,
        height: 34,
        borderWidth: 2,
        borderRadius: 8,
        borderColor: theme.colors.darkGray,
        backgroundColor: theme.colors.darkGray,
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
    },
    containerMiniButtonBisUnselected: {
        flexDirection: 'row',
        width: 88,
        height: 34,
        borderWidth: 2,
        borderRadius: 8,
        borderColor: theme.colors.darkGray,
        backgroundColor: 'transparent',
        alignItems: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        marginVertical: 4,
        paddingVertical: 4,
        paddingHorizontal: 4,
    },
    textButtonNASelected: {
        fontSize: 11,
        fontWeight: 'bold',
        color: 'white',
        marginHorizontal: 2,
    },
    textButtonNAUnselected: {
        fontSize: 11,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
        marginHorizontal: 2,
    },
    textButtonNASelectedBis: {
        fontSize: 14,
        fontWeight: 'bold',
        color: 'white',
        marginHorizontal: 2,
    },
    textButtonNAUnselectedBis: {
        fontSize: 14,
        fontWeight: 'bold',
        color: theme.colors.darkGray,
        marginHorizontal: 2,
    },
    containerYesNoButton: {
        width: 34,
        height: 34,
        borderWidth: 2,
        borderRadius: 17,
        justifyContent: 'center',
        marginRight: 12,
    },
    containerYesNo: {
        width: 42,
        height: 30,
        alignContent: 'center',
        alignContent: 'center',
    },
    containerNa: {
        width: 58,
        height: 24,
        marginHorizontal: 3,
        marginVertical: 6,
    },
    imageYesNo: {
        width: 26,
        height: 26,
        aspectRatio: 1,
        alignSelf: 'center',
        marginTop: 2,
    },
    imageNa: {
        width: 60,
        height: 24,
    },
    textButton: {
        fontSize: 14,
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        marginTop: 5,
    },
    containerTextIcon: {
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 0,
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    flexDirectionRow: {
        flexDirection: 'row',
    },
    marginTopBottom: {
        marginTop: 12,
        marginBottom: 32,
    },
    spacer: {
        height: 4,
    },
    mainInput: {
        height: 35,
        borderRadius: 20,
        backgroundColor: 'white',
        paddingVertical: 3,
        paddingHorizontal: 10,
        fontSize: 15,
        color: theme.colors.textPrimary,
        textAlign: 'center',
        borderWidth: 1,
        borderColor: theme.colors.lightGray,
    },
    accordionHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        marginHorizontal: 15,
        marginBottom: 6,
    },
    accordionLabel: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.colorPrimary,
        marginRight: 8,
    },
    statusBadge: {
        borderWidth: 0,
        borderRadius: 4,
        paddingHorizontal: 6,
        paddingVertical: 2,
        marginRight: 6,
    },
    statusBadgeText: {
        fontSize: 11,
        fontWeight: '400',
    },
    chevronIcon: {
        marginLeft: 2,
    },
    accordionContent: {
        marginTop: 4,
    },
    subItemContainer: {
        marginBottom: 24,
    },
    subItemTitle: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.colorPrimary,
    },
    subInput: {
        height: 35,
        backgroundColor: theme.colors.inputBackground,
        borderRadius: 20,
        paddingVertical: 3,
        paddingHorizontal: 10,
        fontSize: 15,
        color: theme.colors.textPrimary,
    },
})

export default styles
